// Debug utility for Google Auth issues
import { auth, googleProvider } from '../firebase';
import { signInWithPopup } from 'firebase/auth';

export const debugGoogleAuth = async () => {
  console.log('🔍 Starting Google Auth Debug...');
  
  // Check Firebase auth instance
  console.log('Auth instance:', auth);
  console.log('Current user:', auth.currentUser);
  console.log('Auth domain:', auth.config.authDomain);
  
  // Check Google provider
  console.log('Google provider:', googleProvider);
  console.log('Provider ID:', googleProvider.providerId);
  
  // Try to sign in and catch specific errors
  try {
    console.log('Attempting Google sign-in...');
    const result = await signInWithPopup(auth, googleProvider);
    console.log('✅ Success!', result);
    return result;
  } catch (error) {
    console.error('❌ Google Auth Error:', error);
    console.error('Error code:', error.code);
    console.error('Error message:', error.message);
    
    // Common error codes and their meanings
    const errorMeanings = {
      'auth/popup-closed-by-user': 'User closed the popup',
      'auth/popup-blocked': 'Popup was blocked by browser',
      'auth/cancelled-popup-request': 'Another popup was already open',
      'auth/unauthorized-domain': 'Domain not authorized in Firebase',
      'auth/configuration-not-found': 'OAuth not configured properly'
    };
    
    if (errorMeanings[error.code]) {
      console.error('🔧 Likely cause:', errorMeanings[error.code]);
    }
    
    // Check if it's a configuration issue
    if (error.message.includes('configuration')) {
      console.error('⚠️  This suggests OAuth is not properly configured in Google Cloud Console');
    }
    
    throw error;
  }
};

// Log current auth configuration
export const logAuthConfig = () => {
  console.log('📋 Current Auth Configuration:');
  console.log('- Auth Domain:', auth.config.authDomain);
  console.log('- API Key exists:', !!auth.config.apiKey);
  console.log('- Current URL:', window.location.href);
  console.log('- Protocol:', window.location.protocol);
};